import React, { Component } from "react";
import Slider from 'react-slick';


export class Banner extends Component {
    state = {
        show: false,
      }
      render() {
        var slick_slider = {
          dots: false,
          arrow: false,
          autoplay: true,
          infinite: true,
          speed: 1000,
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
  
          responsive: [{
  
            breakpoint: 1199,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1
            }
        },
        {
      
            breakpoint: 1024,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1
            }
        },
        {
      
            breakpoint: 680,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
        };
               
        return (
                
            <Slider className="slick_slider banner_slider banner_slider_2" {...slick_slider} slidesToShow={1} autoplay={false} >
                <div className="slide">
                    <div className="slide_img" style={{ backgroundImage: 'url(./images/slider/slider-main-bg-3.jpg' }}></div>
                    <div className="slide__content">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 no-gutters">
                                    <div className="slide__content--headings d-block text-md-end text-center">
                                        <div className="padding_top10 padding_bottom10">
                                            <h2 data-animation="fadeInDown" className="text-md-start"> Adorning your</h2>
                                            <h2 data-animation="fadeInDown" className="text-md-start"> With <span className="webkit-content-main"> Spotless</span></h2>
                                            <h2 data-animation="fadeInDown" className="text-md-start"> clothes</h2>
                                            <div className="margin_top30 text-end res-767-margin_top20 text-md-start" data-animation="fadeInUp" data-delay="1.4">
                                            <h2  data-animation="fadeInDown" className="text-center bg-circle"></h2>
                                                <div className="slider-icon">
                                                    <div className="ttm-icon ttm-icon_element-size-lg ttm-icon_element-color-skincolor mb-0 text-theme-WhiteColor">
                                                    <a href={process.env.PUBLIC_URL + '/Contact_01'}><i className="flaticon-up-right-arrow-1"></i></a>
                                                    </div>
                                                    <div className="slide-icon-content">
                                                        <h3>8k Happy customers</h3>
                                                        <p> Providing the best possible approach to garment for care<br/>
                                                        and superior service by using the latest dry cleaning </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Slider>    
        )
    }
}

export default Banner;